'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (Component) {
  return Component.displayName || Component.name || 'Component';
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/getDisplayName/getDisplayName.jsx
// module id = 666
// module chunks = 0